/**
 * User: WangMeng
 * Date: 2018-07-17
 * Time: 17:45
 * Desc: 收入地区分布结构
 */

import styles from '../../../common/common.scss';
import React from 'react';
import cns from 'classnames';
import { Table } from 'antd';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class IncomeRegionDistribution extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '收入地区结构变化情况';
        this.state = {
            loading: false,
            prevData: [],
            currentData: []
        };
    }

    formatResponse = (data) => {
        let prevData = [], currentData = [];

        data.forEach((d, i) => {
            if (d.lastAreaName) {
                prevData.push({
                    index: i,
                    areaName: d.lastAreaName,
                    inco: d.lastAreaInco
                });
            }
            if (d.currentAreaName) {
                currentData.push({
                    index: i,
                    areaName: d.currentAreaName,
                    inco: d.currentAreaInco
                });
            }
        });

        return {
            prevData,
            currentData
        };
    };

    getColumns = (name = '上年地区') => {
        return [{
            title: name,
            dataIndex: 'areaName'
        }, {
            title: '营业收入',
            dataIndex: 'inco'
        }];
    };

    render() {
        const { loading, prevData, currentData } = this.state;
        return (
            <div>
                <div className="sub-title">{this.title} &nbsp;</div>
                <div className={cns(styles.doubleTable, 'clearfix')}>
                    <Table
                        bordered
                        rowKey={this.rowKey}
                        loading={loading}
                        dataSource={prevData}
                        columns={this.getColumns('上年地区')}
                        pagination={false}
                    />
                    <Table
                        bordered
                        rowKey={this.rowKey}
                        loading={loading}
                        dataSource={currentData}
                        columns={this.getColumns('当年地区')}
                        pagination={false}
                    />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/IncomeRegionDistribution.jsx